import { useContext } from 'react';
import PermissionLevelContext from 'common/contexts/PermissionLevelContext';

export default function usePermissionLevelContext() {
  return useContext(PermissionLevelContext);
}
